import Img from "../Img";

const ImageWithBody = ({
  src,
  hoverSrc,
  alt,
  className = "",
  imgClassName = "",
  children,
}) => (
  <div
    className={`group relative overflow-hidden rounded-xl ${className}`}
  >
    {/* Base image */}
    <Img
      src={src}
      alt={alt}
      className={`absolute w-full h-full object-cover transition-[transform,opacity] duration-700 ease-out ${hoverSrc ? "group-hover:opacity-0" : ""} ${imgClassName} group-hover:scale-[1.05]`}
    />

    {/* Hover image swap */}
    {hoverSrc && (
      <Img
        src={hoverSrc}
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-0 scale-100 transition-[opacity,transform] duration-700 ease-in-out group-hover:opacity-100 group-hover:scale-[1.12]"
      />
    )}

    {/* Animated shine overlay */}
    <div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300">
      <div className="absolute -left-1/2 top-0 h-full w-1/3 bg-gradient-to-r from-transparent via-white/25 to-transparent blur-[1px] -rotate-6 translate-x-[-30%] group-hover:translate-x-[180%] transition-transform duration-700" />
    </div>

    {/* Subtle gradient depth */}
    <div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-t from-black/20 via-transparent to-black/10" />

    {children && <div className="relative z-[1]">{children}</div>}
  </div>
);

export default ImageWithBody;

